// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#lgpd-identity-verification[data-v-0e30abb9]{margin-bottom:1rem}#lgpd-identity-verification-fields[data-v-0e30abb9]{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between}#required-field-label[data-v-0e30abb9]{font-size:.8rem}", ""]);
// Exports
module.exports = exports;
